export const executivePersonE24ReferenceType = 99;
export const executivePersonMainReferenceType = 0;
export const executivePersonOtherReferenceType = 1;
export const executivePersonRegulationLevelReferenceType = 100;

export const executiveRoleId = "16"; // Jednatel

export const DEFAULT_EXECUTIVE_PERSON = {
  id: "",
  name: "",
  surname: "",
  degreeAfterId: "",
  degreeBeforeId: "",
  degreeBeforeId2: "",
  birthDate: null,
  main: false,
  email: "",
  mobilePhone: "",
  phone: "",
  executiveRoleId: "",
  executiveRoleCustom: "",
  editable: true,
  referenceType: null,
};
